module.exports = __webpack_public_path__ + "img/diagram.98fdc484.svg";